<template>
  <v-container class="pa-5" style="max-width: 700px; margin: auto">
    <!-- Card principal -->
    <Loading v-if="isLoading" :isLoading="isLoading" />

    <v-card
      v-else
      elevation="23"
      class="pa-4 mx-auto"
      max-width="700px"
      rounded="xl"
    >
      <!-- Data del recibo principal -->
      <div v-if="this.datosRecibo">
        <v-row class="text-spacing">
          <v-col cols="6">
            <h5 class="font-weight-bold text-blue mb-1">
              Datos de la póliza a domiciliar
            </h5>
          </v-col>
        </v-row>

        <!-- Datos detallados del recibo -->
        <v-row class="tight-line-spacing">
          <v-col cols="12">
            <p>
              <strong>Contratante:</strong> {{ datosGenerales.pContratante }}
            </p>

            <p><strong>Póliza:</strong> {{ datosGenerales.pPoliza }}</p>
            <p><strong>Moneda:</strong> {{ datosGenerales.pMoneda }}</p>
            <p>
              <strong>Frecuencia de pago:</strong>
              {{ datosGenerales.pFormaPago }}
            </p>
          </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
      </div>

      <!-- Contenedor del botón alineado a la derecha -->
      <div class="d-flex justify-end mb-4">
        <v-btn
          v-if="ocultarBtnCacelar"
          elevation="2"
          class="programaP-btn small-btn"
          @click="mostrarTabla = !mostrarTabla"
        >
          Programa de pagos
        </v-btn>
      </div>

      <!-- Tabla de Programa de Pagos -->
      <v-expand-transition>
        <v-simple-table
          v-show="
            mostrarTabla && Array.isArray(datosRecibo) && datosRecibo.length
          "
        >
          <template v-slot:default>
            <thead>
              <tr style="background-color: #cfe2f3">
                <th class="text-left">Fecha de cobro</th>
                <th class="text-left">Recibo</th>
                <th class="text-left">Importe</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in datosRecibo" :key="index">
                <td>{{ item.pFechaCobro }}</td>
                <td>{{ item.pRecibo }}</td>
                <td>{{ formatCurrency(item.pImporteRecibo) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-expand-transition>

     <v-checkbox
  v-model="accepted"
  :rules="[(v) => !!v || 'Debes aceptar los términos']"
  class="terms-checkbox-custom"
  dense
  hide-details
>
  <template #label>
    <span class="terms-text">
      He leído y acepto los
      <span class="terms-link" @click="abrirModalTyC">
  Términos y Condiciones del servicio
</span>
      y el
      <a
        href="https://latinoseguros.com.mx/sitio2021/aviso-de-privacidad/"
        target="_blank"
        rel="noopener"
        class="terms-link"
        @click.stop
        @mousedown.stop
      >
        Aviso de Privacidad
      </a>
    </span>
  </template>
</v-checkbox>


      <div class="botones-pago-cancelar">
        <!-- Domiciliar: menú con 2 opciones -->
        <v-btn
    :disabled="!accepted"
    color="success"
    dark
    class="domiciliar-btn mr-2"
    @click="consultaFormaPago"
  >
    Domiciliar Póliza
  </v-btn>
        <!-- Enviar liga (igual que tenías) -->
        <v-btn
          v-if="canShowEnvBtn"
          elevation="2"
          class="programaP-btn small-btn"
          @click="enviarURLPago"
        >
          Enviar liga
        </v-btn>

        <!-- Volver (igual que tenías) -->
        <v-btn
          v-if="ocultarBtnCacelar"
          elevation="2"
          class="cancel-btn small-btn"
          @click="cancelarPago"
        >
          Volver
        </v-btn>
      </div>
    </v-card>

    <ModalTokuDomiciliacion ref="tokuDomi" />
    <ModalInfo v-model="showInfo" @input="onInfoClose">
      <template #header>{{ infoHeader }}</template>
      <template #default>
        <p>{{ infoBody }}</p>
      </template>
      <template #footer>
        <v-btn color="primary" @click="showInfo = false">Cerrar</v-btn>
      </template>
    </ModalInfo>

    <ModalEvioDomiciliacioToku ref="transactionModal" />
    <ModalTyC ref="modalTyC" />

  </v-container>
</template>

<script>
import ModalTokuDomiciliacion from "./ModalTokuDomiciliacion.vue";
import ModalInfo from "./ModalInfo.vue";
import ModalTyC from "./ModalTerminosyC.vue";
import ModalEvioDomiciliacioToku from "./ModalEvioDomiciliacioToku.vue";
import { allowedProfiles } from "./allowedUsers.js";
import { mapGetters } from "vuex";
import Loading from "../isep/Tools/loading.vue";
import axios from "axios";
import { getBaseUrl } from "../../store/actions/ModuloActions";

export default {
   components: {
    ModalTokuDomiciliacion,
    ModalEvioDomiciliacioToku,
    Loading,
    ModalInfo,
    ModalTyC
  },
  data() {
    return {
      datosGenerales: null,
      datosRecibo: null,
      activePanels: [],
      //selectedEndosos: [],
      datosEndosos: null,
      filteredEndosos: [],
      searchQuery: "",
      bancosData: [],
      currentPage: 1,
      itemsPerPage: 3,
      isLoading: false,
      ocultarBtnCacelar: true,
      disabled: false,
      disableButtons: true,
      showInfo: false,
      infoHeader: "",
      infoBody: "",
      recibosAMostrar: [],

      checkoutSessionId: "",
      urlToku: "",
      accepted: false,
      mostrarTabla: false,
      menuPago: false,
      metodoPagoSeleccionado: null,

      showToku: false,
      iframeLoaded: false,
    };
  },
  watch: {
    // Observa el array selectedEndosos
    selectedEndosos(newVal) {
      // Actualiza el estado del botón dinámicamente
      if (this.datosRecibo) {
        this.disableButtons = false; // Siempre habilitado si datosRecibo tiene valor
      } else {
        this.disableButtons = !(newVal && newVal.length > 0); // Desactivado si no hay endosos seleccionados
      }
    },
    datosRecibo(newVal) {
      // Si datosRecibo tiene datos, habilita los botones
      if (newVal) {
        this.disableButtons = false;
      } else {
        // Si datosRecibo está vacío, verifica selectedEndosos
        this.disableButtons = !(
          this.selectedEndosos && this.selectedEndosos.length > 0
        );
      }
    },
  },

  computed: {
    ...mapGetters(["getPolizaData"]),

    paginatedEndosos() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = this.currentPage * this.itemsPerPage;
      return this.filteredEndosos.slice(start, end);
    },

    paginatedGroupedEndosos() {
      if (
        !this.groupedEndosos ||
        Object.keys(this.groupedEndosos).length === 0
      ) {
        return {};
      }

      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = this.currentPage * this.itemsPerPage;

      // Convertir los objetos agrupados en un array para paginarlos
      const groupedArray = Object.entries(this.groupedEndosos);

      // Filtrar los elementos de la página actual
      const paginatedArray = groupedArray.slice(start, end);

      // Convertir de nuevo a un objeto agrupado
      return Object.fromEntries(paginatedArray);
    },
    totalPages() {
      return Math.ceil(this.recibosAMostrar.length / this.itemsPerPage);
    },

    selectedEndosos() {
      return this.$store.getters.getSelectedEndosos || [];
    },
    groupedEndosos() {
      if (!this.filteredEndosos || this.filteredEndosos.length === 0) {
        return {};
      }

      // Agrupar recibos por `pEndoso`
      const grouped = this.filteredEndosos.reduce((groups, recibo) => {
        if (!groups[recibo.pEndoso]) {
          groups[recibo.pEndoso] = [];
        }
        groups[recibo.pEndoso].push(recibo);
        return groups;
      }, {});

      const result = {};

      // Separar recibos únicos y grupos
      Object.keys(grouped).forEach((key) => {
        if (grouped[key].length > 1) {
          result[key] = grouped[key]; // Grupos con múltiples recibos
        } else {
          const reciboUnico = grouped[key][0];
          result[reciboUnico.pRecibo] = [reciboUnico]; // Recibo único como un grupo separado
        }
      });

      return result;
    },
    recibosPaginados() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.recibosAMostrar.slice(start, start + this.itemsPerPage);
    },

    currentProfileId() {
      return localStorage.getItem("profileId") || "0";
    },

    canShowEnvBtn() {
      return (
        this.currentProfileId !== "0" &&
        allowedProfiles.includes(this.currentProfileId)
      );
    },
  },

  mounted() {
    console.log("domiciliar", this.getPolizaData);
    this.$store.dispatch("guardaDatosPolizaProvenientesUrl", []);

    const token = localStorage.getItem("token");
    if (token) {
      //console.log("Token ya existe en localStorage:", token);
    } else {
      this.realizarLogin();
    }

    const id = this.$route.query.p;
    const filial = this.$route.query.f || null;
    const i = this.$route.query.i; // Si lo necesitas
    const u = this.$route.query.u; // Si lo necesitas

    if (id || filial || i || u) {
      this.ocultarBtnCacelar = false;

      this.isLoading = true;
      const checkProfileId = setInterval(() => {
        const profileId = localStorage.getItem("profileId");
        if (profileId) {
          clearInterval(checkProfileId); // Detener el intervalo una vez que se encuentra el usuario
          this.buscarPoliza(id, filial, i, u).finally(() => {
            this.isLoading = false; // Desactivar el loading al finalizar
          });
        }
      }, 100); // Verificar cada 100ms
    } else if (this.getPolizaData && this.getPolizaData.pDatosGenerales) {
      this.consultaBancos();
      this.datosGenerales = this.getPolizaData.pDatosGenerales;
      //this.datosRecibo = this.getPolizaData.pDatosRecibo;
      //this.datosEndosos = this.getPolizaData.pEndosos;
      this.procesarRecibos({
        pDatosRecibo: this.getPolizaData.pDatosRecibo,
        pEndosos: this.getPolizaData.pEndosos,
      });

      if (this.datosEndosos && this.datosEndosos.length > 0) {
        this.filteredEndosos = [...this.datosEndosos];
      } else {
        console.log(
          "datosEndosos está vacío o es null, no se asignará a filteredEndosos."
        );
      }
      if (
        !Array.isArray(this.recibosAMostrar) ||
        this.recibosAMostrar.length === 0
      ) {
        this.infoHeader = "Atención";
        this.infoBody = "No se encontró ningún recibo por pagar.";
        this.showInfo = true;
      }
    } else {
      this.$router.push("/pago-en-linea/paso-1"); // Redirigir si no hay datos
    }
  },

  methods: {
     abrirModalTyC() {
    this.$refs.modalTyC.isVisible = true
    document.body.style.overflow = "hidden"
  },
    elegirMetodo(metodo) {
      this.metodoPagoSeleccionado = metodo;
      this.menuPago = false;

      this.consultaFormaPago(metodo);
    },

    formatCurrency(value) {
      if (!value && value !== 0) return "";
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(value);
    },

    async enviarURLPago() {
      const detalleFuente =
        Array.isArray(this.selectedEndosos) && this.selectedEndosos.length > 0
          ? this.selectedEndosos[0]
          : this.datosRecibo;

      const detalles = {
        contratante: detalleFuente.pContratante,
        poliza: this.datosGenerales.pPoliza,
        nuRecibo: detalleFuente.pRecibo,
        estatus: detalleFuente.pEstatus,
        importePagar: detalleFuente.pImporteRecibo,
        moneda: detalleFuente.pMoneda,
        fechaVencimiento: detalleFuente.pFechaVencimiento,
      };

      await this.consultaFormaPago();
      this.$refs.tokuDomi?.close();
      
      this.$refs.transactionModal.openModal({
        transactionDetails: detalles,
        showActions: true,
      });
    },

    procesarRecibos(rawData) {
      // 1) Guardar directamente en propiedades
      this.datosRecibo = rawData.pDatosRecibo;
      this.datosEndosos = rawData.pEndosos;

      // 2) Construir el arreglo final 'recibosAMostrar' según las reglas
      // (a) Si pDatosRecibo viene no nulo:
      if (this.datosRecibo) {
        // Si es un ARRAY y tiene al menos 1, tomar el primer elemento
        if (Array.isArray(this.datosRecibo) && this.datosRecibo.length > 0) {
          this.recibosAMostrar = [this.datosRecibo[0]];
        }
        // Si es un OBJETO (no array), envolverlo en arreglo
        else if (
          typeof this.datosRecibo === "object" &&
          !Array.isArray(this.datosRecibo)
        ) {
          this.recibosAMostrar = [this.datosRecibo];
        } else {
          // Por seguridad, si vienen otros tipos, vaciamos
          this.recibosAMostrar = [];
        }
      }
      // (b) Si no hay datos en pDatosRecibo y sí hay pEndosos:
      else if (
        !this.datosRecibo &&
        Array.isArray(this.datosEndosos) &&
        this.datosEndosos.length > 0
      ) {
        // Mostrar TODOS los endosos
        this.recibosAMostrar = [...this.datosEndosos];
      }
      // (c) Si ni datosRecibo ni endosos (o vienen vacíos), limpiar
      else {
        this.recibosAMostrar = [];
      }
    },
    ordenarPorFecha(recibos) {
      return [...recibos].sort(
        (a, b) => new Date(a.pFechaVencimiento) - new Date(b.pFechaVencimiento)
      );
    },

    deshabilitarRecibo(index, recibosOrdenados) {
      // Verifica si hay recibos anteriores sin seleccionar
      for (let i = 0; i < index; i++) {
        if (
          !this.selectedEndosos.some(
            (e) => e.pRecibo === recibosOrdenados[i].pRecibo
          )
        ) {
          return true; // Recibo no seleccionable
        }
      }
      return false; // Recibo seleccionable
    },

    verificarSeleccion(index, recibosOrdenados, event) {
      const recibo = recibosOrdenados[index];

      if (this.deshabilitarRecibo(index, recibosOrdenados)) {
        // Mostrar alerta
        this.$swal(
          "Debes seleccionar los recibos con fechas más antiguas antes de continuar.",
          "",
          "warning"
        );

        // Desmarcar el checkbox
        event.target.checked = false;

        // Eliminar el recibo del array si fue agregado automáticamente por el v-model
        this.selectedEndosos = this.selectedEndosos.filter(
          (item) => item.pRecibo !== recibo.pRecibo
        );
      } else {
        // Si es válido, actualizar el array selectedEndosos
        if (event.target.checked) {
          // Agregar el recibo si no está ya seleccionado
          if (
            !this.selectedEndosos.some(
              (item) => item.pRecibo === recibo.pRecibo
            )
          ) {
            this.selectedEndosos.push(recibo);
          }
        } else {
          // Eliminar el recibo si se deselecciona
          this.selectedEndosos = this.selectedEndosos.filter(
            (item) => item.pRecibo !== recibo.pRecibo
          );
        }
      }
    },

    imprimirSeleccion(endoso, isChecked) {
      if (isChecked) {
        // Al marcar, dejamos sólo este endoso en el array
        this.selectedEndosos = [endoso];
      } else {
        // Al desmarcar, lo eliminamos dejando el array vacío
        this.selectedEndosos = [];
      }

      // Actualiza el estado en Vuex (si lo necesitas)
      this.$store.dispatch("toggleSelectedEndoso", this.selectedEndosos);
    },

    async buscarPoliza(id, filial, i, u) {
      //this.isLoading = true;
      // Dividir el id en caso de que contenga "/"
      this.showInfo = false;
      let pEsFilial = false;
      if (filial > 0) {
        pEsFilial = true;
      }

      const payload = {
        metodo: "BUSCAPOLIZA",
        data: {
          pPoliza: id,
          pNumFilial: filial,
          pEsFilial: pEsFilial,
          pIdUsuario: u > 0 ? u : localStorage.getItem("profileId"),
        },
      };

      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response && response.data) {
          this.$store.dispatch(
            "guardaDatosPolizaProvenientesUrl",
            response.data
          );
          this.datosGenerales = response.data.pDatosGenerales;
          this.datosRecibo = response.data.pDatosRecibo;

          this.datosEndosos = response.data.pEndosos;
          this.procesarRecibos({
            pDatosRecibo: response.data.pDatosRecibo,
            pEndosos: response.data.pEndosos,
          });

          // Validación para datosEndosos
          if (this.datosEndosos && this.datosEndosos.length > 0) {
            this.filteredEndosos = [...this.datosEndosos];
          } else {
            console.log(
              "datosEndosos está vacío o es null, no se asignará a filteredEndosos."
            );
          }

          if (
            (this.datosEndosos === null || this.datosEndosos.length <= 0) &&
            (this.datosRecibo === null || this.datosRecibo.length <= 0)
          ) {
            this.infoHeader = "Atención";
            this.infoBody = "No se encontró ningún recibo por pagar.";
            this.showInfo = true;
          }

          this.consultaBancos();
        } else {
          this.$swal(
            response.errorMessage,
            response.errorMessage || "No se encontraron datos de la póliza.",
            "error"
          );
        }
      } catch (error) {
        this.$swal({
          title: "No se encontraron datos de la póliza.",
          icon: "error",
          customClass: {
            popup: "custom-swal-popup",
            title: "custom-swal-title",
            content: "custom-swal-text",
          },
        });
      } finally {
        this.isLoading = false;
      }
    },
    async consultaFormaPago() {
      this.isLoading = true;

      // 1) Calcular importe de endosos seleccionados
      let importeEndosos = 0;
      if (Array.isArray(this.selectedEndosos)) {
        importeEndosos = this.selectedEndosos.reduce(
          (total, endoso) => total + (endoso.pImporteRecibo || 0),
          0
        );
      } else if (
        this.selectedEndosos &&
        typeof this.selectedEndosos === "object"
      ) {
        importeEndosos = this.selectedEndosos.pImporteRecibo || 0;
      }

      // 2) Añadir importe del recibo principal
      const importeRecibo = this.datosRecibo?.pImporteRecibo || 0;

      // 3) Total
      const importeTotal = importeEndosos + importeRecibo;

      // Verificar si hay datos en la store
      if (this.$store.state.datosPolizaProvenientesUrl) {
        const datosPoliza = this.$store.state.datosPolizaProvenientesUrl;

        this.datosGenerales = datosPoliza.pDatosGenerales;
        this.datosRecibo = datosPoliza.pDatosRecibo;
        this.datosEndosos = datosPoliza.pEndosos;
      }

      if (this.getPolizaData) {
        this.datosGenerales = this.getPolizaData.pDatosGenerales;
        this.datosRecibo = this.getPolizaData.pDatosRecibo;
        this.datosEndosos = this.getPolizaData.pEndosos;
      }

      const referenciaElegida =
        this.datosRecibo && this.datosRecibo.pReferencia
          ? this.datosRecibo.pReferencia
          : Array.isArray(this.datosEndosos) && this.datosEndosos.length
          ? this.datosEndosos[0].pReferencia
          : "";
      console.log(this.datosRecibo);
      
      // Construcción del payload
      const payload = {
        metodo: "DOMICILIADOSTOKU",
        data: {
          montoTotal: importeTotal,
          idAplicacon: localStorage.getItem("applicationNumber"),
          //idBanco: this.idBanco,
          idBanco: 4,
          referencia: referenciaElegida,
          usuario: localStorage.getItem("profileId"),
          pDatosGenerales: {
            pRamoLetra: this.datosGenerales?.pRamoLetra || "",
            pRamo: this.datosGenerales?.pRamo || "",
            pPoliza: this.datosGenerales?.pPoliza || "",
            pProducto: this.datosGenerales?.pProducto || "",
            pAgente: this.datosGenerales?.pAgente || "",
            pSistema: this.datosGenerales?.pSistema || "",
            pTipoPoliza: this.datosGenerales?.pTipoPoliza || "",
            pFormaPago: this.datosGenerales?.pFormaPago || "",
            pIdCuContratante: this.datosGenerales?.pIdCuContratante || "",
            pNumFilial: this.datosGenerales?.pNumFilial || "",
          },
          pDatosRecibo: {
            pContratante: this.datosGenerales?.pContratante || "",
            pNumFilial: this.datosRecibo?.pNumFilial || "",
            pEndoso: this.datosRecibo?.pEndoso || "",
            pNumInciso: this.datosRecibo?.pNumInciso || "",
            pRecibo: this.datosRecibo?.pRecibo || "",
            pEstatus: this.datosRecibo?.pEstatus || "",
            pImporteRecibo: this.datosRecibo?.pImporteRecibo || 0,
            pMoneda: this.datosRecibo?.pMoneda || "",
            pFechaVencimiento: this.datosRecibo[0]?.pFechaCobro || "Sin Recibo subsecuente",
            pReferencia: this.datosRecibo?.pReferencia || "",
            pIdClienteCU: this.datosRecibo?.pIdClienteCU || "",
            pRamoDescripcion: this.datosRecibo?.pRamoDescripcion || "",
          },
          pEndosos: this.datosEndosos || [],
        },
      };

      try {
        const { data } = await this.$store.dispatch("metodoPost", payload);
        if (data.id && data.url) {
          // Guardas la sesión
          this.checkoutSessionId = data.id;
          this.urlToku = data.url;
          localStorage.setItem("tokuUrl", this.urlToku);
          localStorage.setItem("checkoutSessionId", this.checkoutSessionId);

          this.$refs.tokuDomi.openWithUrl(this.urlToku);
        } else {
          throw new Error("No se obtuvo id/url de Toku");
        }
      } catch (err) {
        this.$swal(
          "Error",
          err.message || "Falló la consulta de pago",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    onInfoClose(isOpen) {
      if (!isOpen) {
        this.$router.push("/pago-en-linea/paso-1");
      }
    },
    async realizarLogin() {
      // Usuario y contraseña hardcodeados
      const usuarioHardcoded = {
        userName: "900721",
        password: "123456",
      };

      try {
        const url = `${getBaseUrl()}security/api/Login`;
        const response = await axios.post(url, usuarioHardcoded, {
          headers: {
            "Content-Type": "application/json",
            XAPPID: "F827FE82207B214D85FB0C8856B1BCB411D4",
          },
        });

        if (response.status === 200 && response.data.flag) {
          // Guardar el token y otros datos en localStorage
          const token = response.data.data.tokenId;
          localStorage.setItem("token", token);
          localStorage.setItem("profileId", response.data.data.profileId);
        } else {
          //console.error("Error en el login:", response.data.errorMessage);
        }
      } catch (error) {
        //console.error("Error en la solicitud de login:", error);
      }
    },
    isSelected(endoso) {
      return this.$store.getters.getSelectedEndosos.some(
        (e) =>
          e.pEndoso === endoso.pEndoso &&
          e.pFechaVencimiento === endoso.pFechaVencimiento
      );
    },
    escucharDatosPoliza() {
      // Escucha el evento emitido desde PasoNumeroPoliza
      EventBus.$on("datosPoliza", (polizaData) => {
        if (polizaData) {
          // Asigna los datos a las propiedades para usarlas en la vista
          this.datosGenerales = polizaData.pDatosGenerales;
          this.datosRecibo = polizaData.pDatosRecibo;
        } else {
          this.$router.push("/pago-en-linea/paso-1"); // Redirige si no hay datos
        }
      });
    },

    async consultaBancos() {
      // Construcción del payload
      const payload = {
        metodo: "CONSULTARBANCOS",
        data: {
          montoTotal: 0,
          idAplicacon: 0,
          idBanco: 0,
          referencia: "string",
          usuario: localStorage.getItem("profileId"),
          pDatosGenerales: {
            pRamoLetra: this.datosGenerales?.pRamoLetra || "",
            pRamo: this.datosGenerales?.pRamo || "",
            pPoliza: this.datosGenerales?.pPoliza || "",
            pProducto: this.datosGenerales?.pProducto || "",
            pAgente: this.datosGenerales?.pAgente || "",
            pSistema: this.datosGenerales?.pSistema || "",
            pTipoPoliza: this.datosGenerales?.pTipoPoliza || "",
          },
          pDatosRecibo: {
            pContratante: this.datosRecibo?.pContratante || "",
            pNumFilial: this.datosRecibo?.pNumFilial || "",
            pEndoso: this.datosRecibo?.pEndoso || "",
            pNumInciso: this.datosRecibo?.pNumInciso || "",
            pRecibo: this.datosRecibo?.pRecibo || "",
            pEstatus: this.datosRecibo?.pEstatus || "",
            pImporteRecibo: this.datosRecibo?.pImporteRecibo || 0,
            pMoneda: this.datosRecibo?.pMoneda || "",
            pFechaVencimiento: this.datosRecibo?.pFechaVencimiento || "",
            pReferencia: this.datosRecibo?.pReferencia || "",
            pIdClienteCU: this.datosRecibo?.pIdClienteCU || "",
            pRamoDescripcion: this.datosRecibo?.pRamoDescripcion || "",
          },
          pEndosos: this.datosEndosos || [],
        },
      };

      this.isLoading = true;

      try {
        // Llamada al store para realizar la consulta
        const response = await this.$store.dispatch("metodoPost", payload);

        if (response && response.data) {
          this.bancosData = response.data;
        } else {
          this.$swal(
            "Error",
            "No se encontraron datos para la consulta de bancos.",
            "error"
          );
        }
      } catch (error) {
        // Manejo de errores
        this.$swal(
          "Error en la Consulta",
          "Ocurrió un error al consultar los bancos. Intente de nuevo.",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    abrirModalFormaDePago() {
      // 1) Calcular importe de endosos seleccionados
      let importeEndosos = 0;
      if (Array.isArray(this.selectedEndosos)) {
        importeEndosos = this.selectedEndosos.reduce(
          (total, endoso) => total + (endoso.pImporteRecibo || 0),
          0
        );
      } else if (
        this.selectedEndosos &&
        typeof this.selectedEndosos === "object"
      ) {
        importeEndosos = this.selectedEndosos.pImporteRecibo || 0;
      }

      // 2) Añadir importe del recibo principal
      const importeRecibo = this.datosRecibo?.pImporteRecibo || 0;

      // 3) Total
      const importeTotal = importeEndosos + importeRecibo;

      // 4) Pasar sólo el importe al modal (sin datos de banco)
      this.$refs.paymentModal.setBancoData({
        importePagar: importeTotal,
      });

      // 5) Abrir el modal
      this.$refs.paymentModal.openModal();
    },

   cancelarPago() {
    const cobranza = localStorage.getItem("cobranza");

    const profileId =
      this.$route.query.u || localStorage.getItem("profileId");

    const applicationNumber =
      this.$route.query.a || localStorage.getItem("applicationNumber");

    const query = {};

    if (profileId && profileId !== "0") {
      query.u = profileId;
    }

    if (applicationNumber && applicationNumber !== "0") {
      query.a = applicationNumber;
    }

    const ruta = {
      path: "/pago-en-linea/paso-1",
      query,
    };

    if (cobranza === "0") {
      this.$router.replace(ruta).then(() => {
        window.location.reload();
      });
    } else {
      this.$router.push(ruta);
    }
  }
  },
};
</script>

<style scoped>

/* Botón verde sólido */
.domiciliar-btn.v-btn {
  background-color: #28a745 !important; /* verde */
  color: #ffffff !important;
  border: none;
  text-transform: none;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 8px;
}

/* Hover / focus */
.domiciliar-btn.v-btn:hover,
.domiciliar-btn.v-btn:focus,
.domiciliar-btn.v-btn:focus-visible {
  background-color: #28a745 !important; 
  color: #ffffff !important;
}

/* Iconos dentro del botón */
.domiciliar-btn.v-btn .v-icon {
  color: #ffffff !important;
}

/* Estado deshabilitado */
.domiciliar-btn.v-btn.v-btn--disabled {
  background-color: #c8e6c9 !important; /* verde pálido */
  color: #ffffff !important;
  opacity: 0.7; /* opcional */
}
.v-card {
  padding: 50px 60px 50px 60px; /* Superior, Derecho, Inferior, Izquierdo */
  border-radius: 30px;
}
.text-blue {
  color: #003366;
}

.text-spacing {
  line-height: 0.1;
}

.text-right {
  text-align: right;
}

.interline-spacing {
  line-height: 0.1;
}
.custom-input {
  padding: 0;
  font-size: 16px;
  height: auto;
  border-radius: 5px;
  background-color: #fff;
  border: none;
}
.full-width {
  width: 100%;
  margin-top: 0;
}
.custom-expansion-panel {
  width: 100%; /* Alineado con el botón */
  box-shadow: none; /* Opcional: Elimina sombras adicionales */
  border: 1px solid #ddd; /* Opcional: Agrega un borde consistente */
}

.custom-input .v-input__control {
  padding: 0px 1px; /* Ajusta el padding interno */
  color: #28a745 !important;
}

.mb-1 {
  margin-bottom: 0px;
}

.tight-line-spacing p {
  line-height: 0.5;
}
.small-btnEndoso {
  padding-right: 20px;
  background-color: #17a2b8 !important;

  color: white;
  font-weight: bold;
}
.small-btn {
  width: auto;
  min-width: 120px;
}

.bank-btn {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.programaP-btn {
  background-color: #17a2b8 !important;
  color: white;
  font-weight: bold;
  margin-left: auto;
}
.cancel-btn {
  background-color: #cc0000 !important;
  color: white;
  font-weight: bold;
}

.btn-azul-cielo {
  font-size: 1rem;
  padding: 0.75rem 1rem;
  width: 150px;
}

.cancel-btn:hover {
  background-color: #ff4d4d !important;
}

.md-radio.md-checked .md-radio-container {
  color: #28a745 !important; /* Verde */
}

.custom-expansion-content {
  line-height: 0; /* Interlineado */

  padding-left: 50px; /* Padding alrededor del contenido */
  font-size: 10px; /* Tamaño del texto */
}
.text-selected {
  color: #28a745 !important; /* Verde brillante */
}
.text-success {
  color: #003366 !important;
}

.value-text {
  font-weight: bold;
  color: #000; /* Negro para los valores */
}

.value-importe {
  font-weight: bold;
  color: #28a745; /* Verde para el importe */
}

/**************************************************/
/******************CHECKBOX************************/
/**************************************************/
.custom-checkbox {
  display: flex;
  align-items: center;
  margin-right: 15px;
  cursor: pointer;
}

/* Ocultar el checkbox nativo */
.custom-checkbox input[type="checkbox"] {
  display: none;
}

/* Estilo del círculo externo */
.custom-checkbox .checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid #ddd;
  border-radius: 50%;
  background-color: white;
  position: relative;
  transition: all 0.3s ease;
}

/* Cambiar color cuando está seleccionado */
.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  background-color: #28a745; /* Verde */
  border-color: #28a745;
}

/* Indicador interno (círculo) */
.custom-checkbox .checkmark::after {
  content: "";
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: all 0.3s ease;
}

/* Mostrar el indicador interno al seleccionar */
.custom-checkbox input[type="checkbox"]:checked + .checkmark::after {
  transform: translate(-50%, -50%) scale(1);
}

.terms-checkbox-custom {
  font-size: 0.9rem;
  line-height: 1.4;
  margin-top: 0.5rem;
}

.terms-text {
  display: inline;
  font-size: 0.9rem;
  color: #444;
  position: relative;
  top: 4px;
}

.terms-link {
  color: #1976d2;
  text-decoration: underline;
  word-break: break-word;
  font-size: inherit;
}
/**************************************************/
/******************MOVIL***************************/
/**************************************************/
/* Pantallas grandes: horizontal */
@media (min-width: 769px) {
  .d-flex.flex-column {
    flex-direction: row !important; /* Horizontal en escritorio */
    justify-content: flex-start;
    align-items: center;
  }

  .custom-input {
    width: auto; /* Ajusta automáticamente el ancho del input */
    margin-bottom: 0; /* Sin espaciado */
    margin-right: 10px; /* Espaciado entre el input y el botón */
  }

  .small-btnEndoso {
    width: auto; /* Botón ajustado automáticamente */
  }
}
.botones-pago-cancelar {
  display: flex;
  flex-direction: row; /* Alineación horizontal */
  justify-content: flex-end; /* Los coloca al final del contenedor */
  gap: 12px; /* Espacio entre “Pagar” y “Cancelar” */
  margin-top: 24px; /* Opcional: separación respecto al contenido superior */
}

/* Opcional: limitar ancho de cada botón en escritorio */
.botones-pago-cancelar .btn-azul-cielo,
.botones-pago-cancelar .cancel-btn,
.botones-pago-cancelar .env-btn {
  min-width: 120px;
}

@media (max-width: 768px) {
  .v-card {
    padding: 18px;
  }
  .d-flex.flex-column {
    flex-direction: column !important;
  }
  .custom-input {
    width: 100%;
    margin-bottom: 10px;
  }

  .text-endoso {
    font-size: 12px;
  }
  .custom-expansion-content {
    line-height: 0; /* Interlineado */

    padding-left: 0px; /* Padding alrededor del contenido */
    font-size: 9px; /* Tamaño del texto */
  }

  .small-btnEndoso {
    width: 100%; /* Botón del mismo ancho que el input */
  }
  .text-paginador {
    font-size: 10px; /* Tamaño más pequeño para móviles */
    margin-bottom: 0; /* Asegura que no haya margen extra */
    line-height: 1;
    text-align: left;
  }
  .num-paginador {
    font-size: 6px;
    white-space: nowrap;
    margin-bottom: 0;
  }
  .botones-pago-cancelar {
    display: flex;
    flex-direction: column; /* Alineación vertical */
    align-items: center; /* Centra cada botón horizontalmente */
    gap: 12px; /* Espacio entre botón y botón */
    margin-top: 20px; /* Opcional: separación respecto al contenido superior */
  }

  /* Que los botones ocupen casi todo el ancho disponible en móvil */
  .botones-pago-cancelar .btn-azul-cielo,
  .botones-pago-cancelar .cancel-btn,
  .botones-pago-cancelar .env-btn {
    width: 100%;
    max-width: 300px;
  }
  .tight-line-spacing p {
    line-height: 1.5;
  }

  .terms-checkbox-custom {
    font-size: 0.6rem;
  }

  .v-input--selection-controls__ripple {
    width: 18px !important;
    height: 18px !important;
  }

  .v-input--selection-controls__input {
    transform: scale(0.9);
  }
}
</style>
